var rich_content_viewer_default = {
  "fontElementMap": "_2DuU1",
  "wrapper": "jbEZV",
  "pluginContainerMobile": "B-7yx",
  "viewer": "ITIQ7",
  "android": "x8IXe",
  "rootedTraversedContent": "_1-7Ba",
  "atomic": "lzxmK",
  "toolbar": "_5FTG8",
  "block": "n7jua"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
